import { APP_VERSION } from 'config/constants'

const getOS = () => {
  const agent = navigator.userAgent.toLowerCase()
  if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
    return 'Windows'
  }
  if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
    return 'Windows'
  }

  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  const MAC =
    /macintosh|mac os x/i.test(navigator.userAgent) && !window.MSStream
  const android = /Android/.test(navigator.userAgent) && !window.MSStream
  if (iOS) {
    return 'ios'
  }
  if (MAC) {
    return 'MAC'
  }
  if (android) {
    return 'Android'
  }
  return 'Others'
}

const getDeviceSizeType = () => {
  const agent = navigator.userAgent
  if (/iPad|tablet/.test(agent)) {
    return 'tablet'
  }
  if (/iPhone|iPad|Android/.test(agent)) {
    return 'mobile'
  }
  const laptopReg = /macintosh|mac os x|win32|wow32|win64|wow64/
  if (laptopReg.test(agent.toLowerCase())) {
    return 'desktop'
  }
  console.warn('device size not detected')
  return 'mobile'
}

const isEdge = () => {
  if (navigator.userAgent.indexOf('edge') > -1) {
    return true
  }
  const brands = navigator.userAgentData?.brands || []
  if (brands.some((brandPair) => brandPair.brand === 'Microsoft Edge')) {
    return true
  }
  return false
}

const getBrowser = () => {
  if (
    (navigator.userAgent.indexOf('Opera') ||
      navigator.userAgent.indexOf('OPR')) !== -1
  ) {
    return 'opera'
  } else if (isEdge()) {
    return 'Edge'
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    return 'Chrome'
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    return 'Safari'
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    return 'Firefox'
  } else if (
    navigator.userAgent.indexOf('MSIE') != -1 ||
    !!document.documentMode === true
  ) {
    return 'IE'
  } else {
    return 'others'
  }
}

export const getSinyiDeviceInfo = (webview) => {
  const os = getOS()
  const deviceSizeType = getDeviceSizeType()
  let apType = 'APP'
  if (webview?.name === 'sinyiWeb') {
    if (deviceSizeType === 'desktop') {
      apType = 'DesktopSite'
    } else {
      apType = 'MobileSite'
    }
  } else if (webview?.name !== 'sinyiApp') {
    console.warn(`invalid webview ${webview?.name}`)
  }
  const browser = getBrowser()

  const sinyiOSTypeMap = {
    Android: 1,
    ios: 2,
    Windows: 3,
    MAC: 4,
    Linux: 5,
    Others: 6,
  }
  const sinyiDeviceTypeMap = {
    mobile: 1,
    tablet: 2,
    desktop: 3,
  }
  const sinyiApTypeMap = {
    APP: 1,
    MobileSite: 2,
    DesktopSite: 3,
    Scheduling: 4,
  }
  const sinyiBrowserMap = {
    none: 1, // APP
    Chrome: 2,
    IE: 3,
    Firefox: 4,
    Safari: 5,
    Opera: 6,
    Edge: 7,
    others: 8,
  }
  return {
    osType: sinyiOSTypeMap[os],
    deviceType: sinyiDeviceTypeMap[deviceSizeType],
    apType: sinyiApTypeMap[apType],
    browser: sinyiBrowserMap[apType === 'APP' ? 'none' : browser],
    appVersion: webview?.appVersion || APP_VERSION,
  }
}

export const getEnvInfo = (webview) => {
  return {
    appVersion: webview?.appVersion || APP_VERSION,
    browserName: getBrowser().toLowerCase(),
    browserVersion: navigator ? navigator.userAgent : null,
    deviceModel: navigator ? navigator.platform : null,
    deviceType: webview?.device || 'web',
    osName: getOS(),
    osVersion: webview?.osVersion || '',
    origin: webview?.name || 'lsWeb',
  }
}

// get env info for query string keys witch starts with underline
const convertToQs = (envInfo) => {
  const entries = Object.entries(envInfo).map(([key, value]) => [
    `_${key}`,
    encodeURIComponent(value),
  ])
  return Object.fromEntries(entries)
}

export const getEnvInfoQs = (webview) => convertToQs(getEnvInfo(webview))
export const getSinyiDeviceInfoQs = (webview) =>
  convertToQs(getSinyiDeviceInfo(webview))
